import gql from 'graphql-tag';

const GET_SLA_CONFIGS = gql`
  query slaConfigs {
    slaConfigs {
      id
      requestType
      recommendedDays
      createdAt
      updatedAt
    }
  }
`;

export default GET_SLA_CONFIGS;
